export default __webpack_public_path__ + "static/media/nigerialogo.8cf737fb.svg";